<template>
  <div class="rating-meter">
    <div class="rating-body">
      <div
        class="rating-fill"
        v-fillable.fill="{ val: meterVal }"
      ></div>
      <div class="rating-cover">
        <img
          :src="`${CFG_WIDGET_URL_BASE || ''}/static-assets/images/cssimages/needle.png`"
          v-fillable.cover="{ val: meterVal }"
          class="needle"
         alt="Needle"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ["meterVal", "CFG_WIDGET_URL_BASE"]
};
</script>
